window.jQuery = require('jquery');
window.$ = window.jQuery;
require('bootstrap');
require('bootstrap-select');
require('jquery-ui/ui/widgets/sortable');
require('eonasdan-bootstrap-datetimepicker');
require('tolnaiz-jcrop');

window.axios = require('axios');
window._ = require('lodash');
window.Vue = require('vue');

var L = require('leaflet');

var map;

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

import Spinner from 'vue-simple-spinner';
Vue.component('vue-simple-spinner', Spinner);

import Autocomplete from '@trevoreyre/autocomplete-vue';

Vue.use(Autocomplete);

var L = require('leaflet');

new Vue({
    el: '.ajax_loader'
});

var megtett_tura = new Vue({
    el: '#megtett_tura_map',
    components: {
        Autocomplete
    },
    methods: {
        display() {
            if (tura.trackpoints.length > 1 || tura.waypoints.length > 1 || tura.routepoints.length > 1) {
                if(tura.trackpoints.length > 1) {
                    var tura_koordinatak = JSON.parse(JSON.stringify(tura.trackpoints));

                    var coordinates = tura_koordinatak;
                    var polyline = L.polyline(coordinates, {color: '#0C59D0'}).addTo(map);
                    map.fitBounds(polyline.getBounds());

                    if(tura.waypoints.length > 1) {
                        var waypoints = JSON.parse(JSON.stringify(tura.waypoints));
                        for (var key in waypoints) {
                            var key2 = waypoints[key];
                            var myIcon = L.divIcon({className: 'fas fa-map-marker div-icon'});
                            var marker = L.marker([coordinates[key2][0], coordinates[key2][1]],
                                {
                                    icon: myIcon
                                }
                            ).addTo(map);

                        }
                    }
                }
                else if(tura.waypoints.length > 1) {
                    var tura_koordinatak = JSON.parse(JSON.stringify(tura.waypoints));

                    axios.post('https://api.openrouteservice.org/v2/directions/'+tura.kategoria.api_nev+'/geojson', {
                    coordinates: tura_koordinatak,
                    elevation: true,
                    instructions: true,
                    language: 'en-US',
                    preference: 'fastest'
                  }).then(function (response) {
                    //console.log(response.data.features);

                    var coordinates = response.data.features[0].geometry.coordinates.map(x => [x[1], x[0]]);

                    var polyline = L.polyline(coordinates, {color: '#0C59D0'}).addTo(map);
                    map.fitBounds(polyline.getBounds());
                    var waypoints = response.data.features[0].properties.way_points;
                    for (var key in waypoints) {
                        var key2 = waypoints[key];
                        var myIcon = L.divIcon({className: 'fas fa-map-marker div-icon'});
                        var marker = L.marker([coordinates[key2][0], coordinates[key2][1]],
                            {
                                icon: myIcon
                            }
                            ).addTo(map);
                        }
                    })

                }
            }
        },
    },
});

window.activate_first_tab = function ($in) {
    if (window.location.hash && $in.find('.nav-tabs a[href="' + window.location.hash + '"]').length > 0) {
        $('.nav-tabs a[href="' + window.location.hash + '"]').tab('show');
    }else{
        // tab active
        var jQuerynavtabs = $in.find('.nav-tabs');
        if (jQuerynavtabs.find('li.active:visible').length == 0) {
            var jQuerytab = jQuerynavtabs.find('li a[href^="#"]:visible').first();
            jQuerytab.tab('show');
        }
    }
}

$('div.nav-tabs a').on('shown.bs.tab', function (e) {
    window.location.hash = e.target.hash;
});

$('form').submit(function(event) {
    $(this).attr('action', $(this).attr('action') + window.location.hash);
});

window.ck_editorok = function () {
    jQuery(".my-ckeditor:not(.attached)").each(function(){
        if(!jQuery(this).attr("id").length){
            return false;
        }
        if (jQuery(this).data('toolbar') == "basic") {
            CKEDITOR.replace(jQuery(this).attr("id"), {
                toolbarGroups : [
                    { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                    { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                    { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                    { name: 'forms', groups: [ 'forms' ] },
                    '/',
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                    { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                    { name: 'links', groups: [ 'links' ] },
                    { name: 'insert', groups: [ 'insert' ] },
                    '/',
                    { name: 'styles', groups: [ 'styles' ] },
                    { name: 'colors', groups: [ 'colors' ] },
                    { name: 'tools', groups: [ 'tools' ] },
                    { name: 'others', groups: [ 'others' ] },
                    { name: 'about', groups: [ 'about' ] }
                ],

                removeButtons : 'Source,Save,NewPage,Templates,Preview,Print,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Replace,Find,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,CopyFormatting,RemoveFormat,Outdent,Indent,CreateDiv,Blockquote,BidiLtr,Language,BidiRtl,Anchor,Image,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Styles,Format,Font,FontSize,TextColor,BGColor,ShowBlocks,Maximize,About,Subscript,Strike,Underline,Unlink',
                docType : '<!DOCTYPE html>',
                emailProtection : 'encode',
                entities_latin : false,
                entities_greek : false,
                forcePasteAsPlainText : true,
                pasteFromWordPromptCleanup : true,
                width : '100%',
            });
        }else{
            CKEDITOR.replace(jQuery(this).attr("id"), {
                customConfig: '/a/ckeditor_config.js'
            });
        }

        jQuery(this).addClass('attached');
    });
}

jQuery(document).on('click', '.confirm', function() {
    return confirm('Biztos benne?');
});

jQuery(document).ajaxStart(function () {
    jQuery('.ajax_loader').show();
});

jQuery(document).ajaxStop(function () {
    jQuery('.ajax_loader').hide();
});

jQuery(document).ready(function($) {

    ck_editorok();
    jQuery('.bs-select').selectpicker({
        noneSelectedText: '(válasszon)',
        liveSearch: true,
        liveSearchPlaceholder: '(keresés)'
    });

    activate_first_tab($('body'));
    jQuery.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
        }
    });

    // törlés gomb
    jQuery(document).on('click', '.torol', function(e) {
        e.preventDefault();
        if (confirm('Biztos benne?')) {
            var jQuerythis = jQuery(this);
            jQuery.ajax({
                url: jQuerythis.attr('href'),
                method: 'DELETE',
                success: function(resp) {
                    jQuery('#item_' + resp.id).remove();
                },
                error: function() {
                    alert('Hiba történt');
                }
            });
        }
    });

    function rendezheto() {
        jQuery('.rendezheto').sortable({
            update: function (event, ui) {
                var jQuerythis = jQuery(this);
                console.log(jQuerythis.data('action'));
                jQuery.post(jQuerythis.data('action'), {
                    data: jQuerythis.sortable('serialize')
                });
            }
        });
    }
    rendezheto();
    // kötelető mezőkhöz piros csillag
    jQuery('[required]').each(function() {
        jQuery(this).parents('.form-group').find('label').first().append('&nbsp;<span class="text-danger" title="Kötelező mező">*</span>');
    });

    //megtett túra nézet
    if(document.getElementById('megtett_tura_map')) {
        map = L.map('megtett_tura_map').setView([46,18], 10);
        L.tileLayer('https://maps.heigit.org/openmapsurfer/tiles/roads/webmercator/{z}/{x}/{y}.png', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
        maxZoom: 18,
        }).addTo(map);

        megtett_tura.display();
    }

    // hibás mezők jelölése + tab fül
    jQuery(':input').on('invalid', function() {
        window.scrollTo(0, 0);

        var jQuerythis = jQuery(this),
            id = jQuerythis.parents('.tab-pane').attr('id');

        jQuery('a[href="#' + id + '"]').addClass('text-danger');
        jQuerythis
            .after('<span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"></span>' +
                '<span class="sr-only">(kötelező mező)</span>')
            .parents('.form-group').addClass('has-error has-feedback');
    });

    // hibás mezők jelölése küldés után
    jQuery('.alert.alert-danger[data-danger-fields]').each(function() {
        var mezo;
        jQuery.each(jQuery(this).data('danger-fields'), function(i, field) {
            mezo = field.toString().split('.').join('');
            jQuery('#' + mezo)
                .after('<span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"></span>')
                .parents('.form-group').addClass('has-error has-feedback');
        });
    });

    jQuery('.datetime-picker').datetimepicker({
        locale: 'hu',
        format: 'YYYY-MM-DD HH:mm',
        icons: {
            time: 'oi oi-timer',
            date: 'oi oi-calendar',
            up: 'oi oi-arrow-thick-top',
            down: 'oi oi-arrow-thick-bottom',
            previous: 'oi oi-arrow-thick-left',
            next: 'oi oi-arrow-thick-right',
            today: 'oi oi-flash',
            clear: 'oi oi-trash',
            close: 'oi oi-delete'
        },
        dayViewHeaderFormat: 'YYYY MMMM'
    });

    jQuery('.datepicker').datetimepicker({
        locale: 'hu',
        format: 'YYYY-MM-DD',
        icons: {
            time: 'oi oi-timer',
            date: 'oi oi-calendar',
            up: 'oi oi-arrow-thick-top',
            down: 'oi oi-arrow-thick-bottom',
            previous: 'oi oi-arrow-thick-left',
            next: 'oi oi-arrow-thick-right',
            today: 'oi oi-flash',
            clear: 'oi oi-trash',
            close: 'oi oi-delete'
        },
        dayViewHeaderFormat: 'YYYY MMMM'
    });

    jQuery('.time-picker').datetimepicker({
        locale: 'hu',
        format: 'HH:mm:ss',
        icons: {
            time: 'oi oi-timer',
            date: 'oi oi-calendar',
            up: 'oi oi-arrow-thick-top',
            down: 'oi oi-arrow-thick-bottom',
            previous: 'oi oi-arrow-thick-left',
            next: 'oi oi-arrow-thick-right',
            today: 'oi oi-flash',
            clear: 'oi oi-trash',
            close: 'oi oi-delete'
        },
        dayViewHeaderFormat: 'YYYY MMMM'
    });

    jQuery('.custom-file-input').on('change', function() {
        let fileName = jQuery(this).val().split('\\').pop();
        jQuery(this).next('.custom-file-label').addClass("selected").html(fileName);
    });

    function menu_tipus() {
        var jQuerythis = jQuery(this),
            value = jQuerythis.val();

        if (value == 'szoveg') {
            jQuery('#szoveg_id').attr('required', 'required').prop('required', 'required').parents('.form-group').slideDown();
        } else {
            jQuery('#szoveg_id').removeAttr('required').removeProp('required').parents('.form-group').slideUp();
        }
    }
    jQuery('.menu_tipus').each(menu_tipus);
    jQuery('.menu_tipus').on('change', menu_tipus);


    var jcrop_promises = [];
    jQuery('.jcrop').each(function() {
        var jQuerythis = jQuery(this),
            name = jQuerythis.data('name') || '_kivagasok',
            aspectRatio = jQuerythis.data('aspect-ratio') || 1,
            selection = jQuerythis.data('selection'),
            jQueryinput = jQuery('<input type="hidden" name="' + name + '[' + aspectRatio + ']">');

        jQuerythis.parent().append(jQueryinput);
        var p = new Promise(function(resolve, reject) {
            setTimeout(function() { // hack!
                if(!selection || typeof selection != 'object'){
                    selection = {'x': 0, 'y': 0, 'x2': 0, 'y2':0};
                }

                jQuerythis.Jcrop({
                    trueSize: [
                        jQuerythis.get(0).naturalWidth,
                        jQuerythis.get(0).naturalHeight
                    ],
                    keySupport: false,
                    aspectRatio: aspectRatio,
                    onChange: function(c) {
                        jQueryinput.val(JSON.stringify(c));
                    },
                    onSelect: function(c) {
                        jQueryinput.val(JSON.stringify(c));
                    },
                    setSelect: [
                        selection.x,
                        selection.y,
                        selection.x2,
                        selection.y2
                    ],
                    boxWidth: jQuerythis.width() || 900, // hack 2!
                    bgColor: 'black'
                });
                resolve();
            }, 400);
        });
        jcrop_promises.push(p);
    });

    // $('.api_import_button').on('click', function (e) {
    //     e.preventDefault();
    //     axios.get('/admin/api_import').then(function (response) {
    //         console.log(response);
    //         alert('Rendezvények sikeresen importálva külső forrásból.');
    //         window.location.href = '/admin/rendezveny';
    //     });
    // });
});



// WEBPACK FOOTER //
// ./resources/js/admin.js